module.exports = __webpack_public_path__ + "img/sticker-safe.a0a83357.svg";